import { createAsyncThunk } from '@reduxjs/toolkit';
import { getPodDataByContactId } from 'services/pod';
import { IPodDataSimlified } from 'services/pod/types';

interface IProps {
  crmId: number;
  contactId: string;
}

export const ThunkGetPodDataByContactId = createAsyncThunk<IPodDataSimlified, IProps>(
  'pod/getPodDataByContactId',
  ({ crmId, contactId }) => getPodDataByContactId(crmId, contactId).then(res => res.data),
);
